$(document).ready(function () {

    $('.more-courses-btn').click(function (e) {
        e.preventDefault();
        var btn = $(this);
        var next = $(this).next();
        next.toggleClass('active');
        next.hasClass('active') ? btn.addClass('open').text('Show less') : btn.removeClass('open').text('Show more');
    });


    // remove episerver form stylesheet

    $('link[rel=stylesheet][data-epiforms-resource="EPiServerForms.css"]').remove();

    // product / solution page navigation

     var current = $(".techInfo h2");
     current.attr("id", "heading1");
     $(".tocHeading1").append("<a href='#heading1" +
         "' title='" + current.attr("tagName") + "'>" + current.html() + "</a>");

     var current = $(".navHeading");
     current.attr("id", "heading2");
     $(".tocHeading2").append("<a href='#heading2" +
         "' title='" + current.attr("tagName") + "'>" + current.html() + "</a>");

     $(".techInfo h3").each(function (i) {
         var current = $(this);
         current.attr("id", "title" + i);
         $(".toc").append("<li> <a href='#title" +
             i + "' title='" + current.attr("tagName") + "'>" +
             current.html() + "</a></li>");
     });
   

    // product nav target
    var wwtoc = document.querySelector(".ww__toc");
    if (wwtoc) {
        document.querySelectorAll("main .ww__nav-target").forEach(function (item) {
            if (item.nextElementSibling && item.nextElementSibling.nodeName === "A") {
                var li = document.createElement("li");
                var a = document.createElement("a");
                a.setAttribute("href", item.nextElementSibling.getAttribute("href"));
                a.textContent = item.textContent;
                li.appendChild(a);
                wwtoc.appendChild(li);
            }
        });
    }

    // course schedule page navigation

    $(".courseCategories h2 a").each(function (i) {
        var current = $(this);
        current.attr("id", "title" + i);
        $(".coursetoc").append("<li> <a href='#title" +
            i + "' title='Go to " + current.html() + "'>" +
            current.html() + "</a></li>");
    });



    // touch device detection

    $(document).on('touchstart', function () {
        $('body').addClass('touchDevice');
    });





    // scroll to #anchor

    $('.inPage a, .anchorLinks a').on('click', function () {
        var target = $(this.hash);
        $('html,body').animate({
            scrollTop: target.offset().top
        }, 500, function() {
            target.addClass('target');
        });
        return false;
    });





    // sticky nav

    $(window).on('scroll', function () {
        if ($(window).scrollTop() > 300) {
            $('.anchorLinks').addClass('above');
        }
        else {
            $('.anchorLinks').removeClass('above');
        }
    });





    // gotoTop button

    $(window).on('load', function () {

        $('body').prepend('<span class="gotoTop"></span>');

        var previousScroll = 0;

        $(window).scroll(function () {
            var currentScroll = $(this).scrollTop();
            if (currentScroll < previousScroll && currentScroll > 100) {
                $('.gotoTop').addClass('active');
            } else {
                $('.gotoTop').removeClass('active');
            }
            previousScroll = currentScroll;
        });

        $('.gotoTop').on('click', function () {
            $('html, body').animate({ scrollTop: 0 }, 500);
            $(this).addClass('clicked');
            setTimeout(function () {
                $('.gotoTop').removeClass('clicked')
            }, 1000);
        });

    });





    // frontpage and inverse classes to observe fixed bgs

    if ($('body').hasClass('frontpage')) {
        $('html').addClass('frontpage');
    }

    if ($('.inverse').length) {
        $('html').addClass('hasInverse');
    }





    // searchFilter open / close (screen < desktop)

    $('.searchFilter h2 span').on('click', function () {
        $(this).closest('section').toggleClass('open');
    });





    // factMap number reduce font-size if line breaks

    $(window).on('load', function () {
        $('.factMap h3 strong').each(function () {

            var singleHeight = parseInt($(this).css('line-height'));
            var fontSize = parseInt($(this).css('font-size'));

            while ($(this).height() > singleHeight && fontSize > 20) {
                singleHeight = parseInt($(this).css('line-height'));
                $(this).closest('.factMap').find('h3 strong').css('font-size', fontSize -= 10);
            }
        });
    });





    // number counter

    $(window).on('load', function () {
        $('.hero .number').each(function () {
            $(this).prop('Counter', 0).animate({
                Counter: Number($(this).text())
            }, {
                duration: 1500,
                step: function (now) {
                    $(this).text(Math.ceil(now));
                }
            });
        });
    });




    // sticky contact button

    if ($('aside .contact').length) {
        $(window).on('scroll', function () {

            var contactBottom = $('aside .contact:first').offset().top + $('aside .contact:first').height()
            var scrollPosition = $(window).scrollTop()

            if (contactBottom < scrollPosition) {
                $('aside .contact:first').addClass('above');
            }
            else {
                $('aside .contact:first').removeClass('above');
            }

        });
    }

    $('aside .contact:first h2').on('click', function () {
        if ($(this).parent().hasClass('above')) {
            $('html, body').animate({
                scrollTop: $(this).parent().offset().top
            }, 500);
        }
    });





    // flowList oneLine scroll

    $('.oneLine').each(function () {

        var visibleWidth = $(this).width();
        var longDistance = $(this).children('li:nth-of-type(3)').position().left;
        var shortDistance = $(this).children('li:nth-of-type(2)').position().left;

        // scroll right
        $(this).siblings('.scroll.right').on('click', function () {
            $(this).siblings('button').addClass('active');
            if (longDistance < visibleWidth) {
                $(this).siblings('ul').animate({
                    scrollLeft: '+=' + longDistance
                });
            }
            else {
                $(this).siblings('ul').animate({
                    scrollLeft: '+=' + shortDistance
                });
            }
        });

        // scroll left
        $(this).siblings('.scroll.left').on('click', function () {
            if (longDistance < visibleWidth) {
                $(this).siblings('ul').animate({
                    scrollLeft: '-=' + longDistance
                });
            }
            else {
                $(this).siblings('ul').animate({
                    scrollLeft: '-=' + shortDistance
                });
            }
        });

        // hide scroll buttons on touch
        $(this).on('touchmove', function () {
            if ($(this).children('li:first').position().left < 0) {
                $(this).siblings('button').hide();
            }
        });

    });





    // sub nav expansion

    $('nav.sub ul').on('click', function () {
        $(this).closest('nav').toggleClass('open');
    });

    $('nav.sub .selected a').on('click', function (evt) {
        evt.preventDefault();
    });





    // table overflow detect */

    $(window).on('load', function () {

        $('table').each(function () {
            if ($(this).width() > $('body').width()) {
                $(this).addClass('fat');
                $(this).before('<div class="tableZoom"><button><span class="visually-hidden-accessible">Expand or shrink table</span></button></div>');
            }
        });

        $('.bodyText table:not(.innerWide)').each(function () {
            if ($(this).width() > $('.bodyText').width()) {
                $(this).addClass('fat');
                $(this).before('<div class="tableZoom"><button><span class="visually-hidden-accessible">Expand or shrink table</span></button></div>');
            }
        });

        $('.tableZoom').on('click', function () {
            $(this).next('table').toggleClass('makeWide');
            $(this).toggleClass('active');
        });

    });





    // zoomable

    $('.zoomable').on('click', function () {
        $(this).toggleClass('innerWide');
    });





    // gallery thumb clicks

    $('.gallery .thumbs a').on('click', function (evt) {
        evt.preventDefault();
        $('#galleryMain').empty();
        $('#mainCaption').empty().append(
			$(this).children().attr('title')
		);
    });
    $('.gallery .thumbs a:not(.video)').on('click', function (evt) {
        $('#galleryMain').append(
	      	$('<img>', { src: this.href, alt: $(this).children().attr('alt') })
		);
    });
    $('.gallery .thumbs a.video.stream').on('click', function (evt) {
        $('#galleryMain').append(
	      	$('<iframe>', { src: this.href })
		);
    });
    $('.gallery .thumbs a.video.file').on('click', function (evt) {
        $('#galleryMain').append(
	      	$('<video>', { src: this.href, controls: true })
		);
    });





    // gallery zoom

    $('.gallery--expandable').prepend('<button class="zoom"><span class="visually-hidden-accessible">Expand or shrink gallery</span></button>');

    $('#galleryMain').on('mouseenter mouseleave', function () {
        $(this).parent().toggleClass('hoverCurrent');
    });

    $('.gallery--expandable .zoom').on('click', function () {
        $('main').toggleClass('galleryWide');
    });





    // menu, search buttons
    var searchForm = document.querySelector(".header__top-column form");
    var headerBottom = document.querySelector(".header__bottom");
    $('.menuBtn').on('click', function () {
        if($('html').hasClass('menu_open')) {
            $('.has-mega-menu .active').removeClass('active');
            headerBottom ? headerBottom.scrollTop = 0 : null;
        }

        searchForm ? searchForm.classList.remove("active") : null;
        $('html').toggleClass('menu_open');
    });





    // mega menu close button

    $('.header__bottom .mega').prepend('<button class="closeBtn"><span class="visually-hidden-accessible">Close menu</span></button>');

    $('.mega .closeBtn').on('click', function () {
        $('.mega').addClass('closed');

        setTimeout(function () {
            $('.mega').closest('.header__bottom-list-item').removeClass('active');
            $('.mega').removeClass('closed');
        }, 1000);
    });


    if ($('.courseNav').length) {
        var distance = $('.courseNav').offset().top,
		$window = $(window);

        $window.scroll(function () {
            if ($window.scrollTop() >= distance) {
                // Your div has reached the top
                $('.courseNav').addClass('sticky');
            } else if ($window.scrollTop() <= distance) {
                $('.courseNav').removeClass('sticky');
            }
        });
    }



}); /* end */












